module.exports = __webpack_public_path__ + "img/logo.43307c56.png";